export const queryKeys = {
  roles: {
    all: ["roles"] as const,
    lists: () => [...queryKeys.roles.all, "list"] as const,
    list: (activeOnly: boolean) =>
      [...queryKeys.roles.lists(), { activeOnly }] as const,
  },
};
